import React, { useEffect } from "react";
import { SendBulkMessage } from "./SendBulkMessage";
import { FormValues } from "./types";
import { useCreateBulkMessage } from "@/hooks/useCreateBulkMessage";
import { CURRENT_USER } from "@/api/queries/currentUser";
import { useOrg } from "@/hooks/useOrg";
import { useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { useRoute } from "@/routes/getRoute";

export function NewBulkMessage() {
  const { org, loading: orgLoading } = useOrg();
  const { data: userData, loading: userLoading } = useQuery(CURRENT_USER);

  const [createBulkMessage, { loading, data, error }] = useCreateBulkMessage();
  const navigate = useNavigate();
  const getRoute = useRoute();

  const route = getRoute("bulkMessageBasicInfo");

  useEffect(() => {
    navigate(route);
  }, [navigate, route]);

  const submitForm = (values: FormValues, { draft = false }) => {
    if (!org?.id || !userData) {
      return;
    }

    return createBulkMessage({
      formValues: values,
      orgId: org?.id,
      userId: userData?.me?.id,
      draft,
    });
  };

  return (
    <SendBulkMessage
      submissionData={data}
      loading={loading || orgLoading || userLoading}
      isActive={false}
      askSaveDraft={false}
      submitHandler={submitForm}
      error={error}
    />
  );
}
